import { Theme, alpha } from '@mui/material';

export default {
    iconStyle: { fontSize: '14px', color: (theme: Theme) => alpha(theme.palette.text.primary, 0.64), cursor: 'move' },
};
